@if (successionFacade.confirmationInformation$ | async; as confirmationInformation) {
  <section
    class="tw-mt-5 tw-flex tw-flex-col tw-border tw-border-solid tw-bg-white tw-px-5 tw-py-7.5 tw-font-bnpp-sans sm:tw-mt-7.5 sm:tw-px-7.5 sm:tw-py-10"
  >
    <div class="tw-flex tw-flex-col tw-items-center sm:tw-flex-row">
      <ia-icons name="circle_check_filled_part" class="tw-h-12.5 tw-shrink-0" />
      <div class="tw-flex tw-flex-col tw-pt-4 sm:tw-pl-7.5 sm:tw-pt-0">
        <p
          class="tw-font-sans tw-text-lg tw-font-semibold"
          [innerHTML]="
            'screens.confirmation.information'
              | translate: { deceaseName: confirmationInformation.deceasedInformation }
          "
        ></p>
        <p class="tw-font-sans tw-text-base">
          {{
            'screens.confirmation.email'
              | translate: { mail: confirmationInformation.reporterEmail }
          }}
        </p>
        <p class="tw-mt-3 tw-font-sans tw-text-base">
          {{ 'screens.confirmation.description1' | translate }}
        </p>
        <p class="tw-font-sans tw-text-base">
          {{ 'screens.confirmation.description2' | translate }}
        </p>
        <p class="tw-mt-3 tw-text-base">
          {{ 'screens.confirmation.contact.label1' | translate }}
        </p>
        <p class="tw-text-base">
          {{ 'screens.confirmation.contact.label2' | translate }}

          <a
            [href]="'screens.confirmation.contact.link' | translate"
            class="tw-mt-3 tw-text-sea-green tw-underline hb-group:tw-text-cerulean"
          >
            {{ 'screens.confirmation.contact.linkLabel' | translate }}
          </a>
        </p>
      </div>
    </div>
  </section>
}

<div class="tw-mt-5 tw-flex tw-justify-center sm:tw-justify-end">
  <button
    (click)="onNext()"
    iaButton
    type="button"
    id="btn-deceased-information-next"
    data-test-id="btn-deceased-information-next"
    variant="primary"
  >
    {{ 'screens.confirmation.button.label' | translate }}
  </button>
</div>
